import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ProjectReducer(state = initialState.projectreportingContent, action: any) {
  switch (action.type) {
    case types.SAVE_PROJECTREPORTINGCONTENT_SUCCESS:
      return action.projectreportingContent;
    default:
      return state;
  }
}
